import { z } from 'zod';
export const Ping = z.object({
    nonce: z.string().min(1),
    sentAt: z.number().int().nonnegative(),
});
export const Pong = z.object({
    nonce: z.string().min(1),
    sentAt: z.number().int().nonnegative(),
    echoedAt: z.number().int().nonnegative(),
});
export const NetworkStats = z.object({
    rttMs: z.number().nonnegative(),
    bandwidthBps: z.number().nonnegative(),
    lossPct: z.number().min(0).max(1),
});
//# sourceMappingURL=liveness.js.map